import { ErrorType } from '../types/index.js';
import { ConcreteException } from '../base.js';
import { mapErrorMessage } from '../utils/maps.js';
const removeMetamaskFromErrorString = (message) => message
    .replaceAll('Metamask', '')
    .replaceAll('MetaMask', '')
    .replaceAll('Metamask:', '');
export class MetamaskException extends ConcreteException {
    static errorClass = 'MetamaskException';
    constructor(error, context) {
        super(error, context);
        this.type = ErrorType.WalletError;
    }
    parse() {
        const { message } = this;
        if (message
            .trim()
            .toLowerCase()
            .includes('missing or invalid parameters'.toLowerCase())) {
            this.setMessage('Please make sure you are using Metamask Wallet');
        }
        else {
            this.setMessage(mapErrorMessage(removeMetamaskFromErrorString(message)));
        }
        this.setName(MetamaskException.errorClass);
    }
}
